import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'inactive-phone-number-warning:popup-title': {
    id: 'inactive-phone-number-warning:popup-title',
    defaultMessage: 'Phone number no longer active',
    description: 'Inactive phone number: popup title',
  },
  'inactive-phone-number-warning:popup-description': {
    id: 'inactive-phone-number-warning:popup-description',
    defaultMessage: 'Your phone number is no longer active. Please try logging in with another mobile phone number.',
    description: 'Inactive phone number: popup text',
  },
});
